export default (axios, alert) => ({
  /**
   * Get alternative offer for customer
   * GET /customer/alternativeOffer
   */
  get () {
    return axios.get('/customer/alternativeOffer').then(({ data }) => data)
  },

  /**
   * Accept alternative offer and switch vorgangsnummer
   * POST /customer/alternativeOffer/accept
   */
  accept (vorgangsnummer) {
    return axios.post('/customer/alternativeOffer/accept', {
      vorgangsnummer
    }).then(({ data }) => data)
  }

})
